var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("商品管理")]),
              _c("el-breadcrumb-item", [_vm._v("上菜管理")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "领货日期：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择领货日期",
                                size: "small",
                              },
                              model: {
                                value: _vm.listParams.plaSupplyDateId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.listParams,
                                    "plaSupplyDateId",
                                    $$v
                                  )
                                },
                                expression: "listParams.plaSupplyDateId",
                              },
                            },
                            _vm._l(_vm.dateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { value: item.id, label: item.title },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: {
            "show-pager-on-one-page": false,
            "page-info": _vm.pager,
            loading: _vm.tableLoading,
          },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: {
                      disabled: _vm.tableData.length === 0,
                      type: "primary",
                      size: "small",
                    },
                    on: { click: _vm.adjustData },
                  },
                  [_vm._v(" 调整数据 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: {
                      disabled: _vm.tableData.length === 0,
                      type: "success",
                      size: "small",
                    },
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible = true
                      },
                    },
                  },
                  [_vm._v(" 确认上菜 ")]
                ),
                _vm.deliveryTakenDate
                  ? _c(
                      "div",
                      {
                        staticClass: "table-info-display",
                        staticStyle: { "font-weight": "600" },
                      },
                      [
                        _c("span", [_vm._v("领货日期：")]),
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDate")(_vm.deliveryTakenDate, true)
                            )
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  align: "center",
                  width: "60",
                  label: "序号",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  width: "120",
                  prop: "title",
                  align: "center",
                  label: "产品名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  width: "100",
                  prop: "spec",
                  align: "center",
                  label: "规格",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  width: "120",
                  prop: "ability",
                  align: "center",
                  label: "基地供应能力",
                },
              }),
              _vm._l(_vm.columnList, function (item, index1) {
                return _c(
                  "el-table-column",
                  {
                    key: index1,
                    attrs: { align: "center", label: item.title },
                  },
                  _vm._l(item.secondTitle, function (item2, index2) {
                    return _c("el-table-column", {
                      key: index2,
                      attrs: {
                        align: "center",
                        label: item2,
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return _vm._l(
                                scope.row.baseList,
                                function (tableItem, index3) {
                                  return _c(
                                    "div",
                                    {
                                      key: index3,
                                      staticClass: "line-height-style",
                                      attrs: {
                                        title: tableItem[index1][index2],
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(tableItem[index1][index2]) +
                                          " "
                                      ),
                                    ]
                                  )
                                }
                              )
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.itemParams,
                    rules: _vm.checkItemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c("el-form-item", [
                    _c("span", [
                      _vm._v("菜品一经上架，顾客即可下单购买，是否确认上菜？"),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.isDisabled,
                            size: "small",
                            type: "primary",
                          },
                          on: { click: _vm.confirmDishing },
                        },
                        [_vm._v(" 确认上菜 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }